import React from 'react';
import { Book, CheckCircle, Shield, FileText, Activity, Users, Lock, AlertTriangle, TrendingUp, Megaphone, MessageSquare, Target } from 'lucide-react';
export function LibraryTeaserSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-50 border-t border-gray-100" data-id="element-873">
      <div className="max-w-7xl mx-auto" data-id="element-874">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-875">
          <h2 className="text-sm font-bold tracking-widest text-gray-500 uppercase mb-4 font-sans" data-id="element-876">
            WHAT COULD YOU BUILD?
          </h2>
          <p className="text-3xl md:text-4xl font-['Syne'] font-bold text-black mb-6" data-id="element-877">
            Smart organizations are capturing their
            <br data-id="element-878" />
            institutional intelligence right now.
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-879">
            Here's what their libraries look like:
          </p>
        </div>

        {/* Library Cards Grid - 3 COLUMNS */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-880">
          {/* Pharma Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-881">
            <div className="p-8" data-id="element-882">
              <div className="mb-6" data-id="element-883">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-884">
                  PHARMA
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-885">Life Sciences</p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-886">
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-888" />} text="Brand Voice (Consumer)" data-id="element-887" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-890" />} text="Brand Voice (HCP)" data-id="element-889" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-892" />} text="FDA Promotional Compliance" data-id="element-891" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-894" />} text="Adverse Event Protocol" data-id="element-893" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-896" />} text="Clinical Trial Messaging" data-id="element-895" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-898" />} text="Patient Privacy (HIPAA)" data-id="element-897" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-900" />} text="Crisis Communication" data-id="element-899" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-902" />} text="Executive Ghostwriting" data-id="element-901" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-903">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-904">
                <TrendingUp className="w-5 h-5 text-green-600" data-id="element-905" />
                <span className="text-sm font-medium text-green-800" data-id="element-906">
                  Result: <span className="font-bold" data-id="element-907">7 days → 1 day</span>{' '}
                  approval cycles
                </span>
              </div>
            </div>
          </div>

          {/* Financial Services Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-908">
            <div className="p-8" data-id="element-909">
              <div className="mb-6" data-id="element-910">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-911">
                  FINANCIAL SERVICES
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-912">
                  Wealth Management
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-913">
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-915" />} text="SEC Compliance (Forward-Looking)" data-id="element-914" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-917" />} text="FINRA Social Media" data-id="element-916" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-919" />} text="Client Segmentation (HNW vs. Retail)" data-id="element-918" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-921" />} text="Risk Disclosure Language" data-id="element-920" />
                <GuardrailItem icon={<CheckCircle className="w-4 h-4" data-id="element-923" />} text="Fiduciary Standard Adherence" data-id="element-922" />
                <GuardrailItem icon={<TrendingUp className="w-4 h-4" data-id="element-925" />} text="Market Commentary Guardrails" data-id="element-924" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-927" />} text="Counterfactual Reasoning" data-id="element-926" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-929" />} text="Annual Review Documentation" data-id="element-928" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-930">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-931">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-932" />
                <span className="text-sm font-medium text-green-800" data-id="element-933">
                  Result:{' '}
                  <span className="font-bold" data-id="element-934">Zero compliance incidents</span>{' '}
                 
                </span>
              </div>
            </div>
          </div>

          {/* Marketing & Communications Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-935">
            <div className="p-8" data-id="element-936">
              <div className="mb-6" data-id="element-937">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-938">
                  MARKETING
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-939">
                  Enterprise Brand
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-940">
                <GuardrailItem icon={<Megaphone className="w-4 h-4" data-id="element-942" />} text="Brand Voice Consistency" data-id="element-941" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-944" />} text="Audience Segmentation (B2B vs. B2C)" data-id="element-943" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-946" />} text="Legal Disclaimer Requirements" data-id="element-945" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-948" />} text="Competitor Mention Policy" data-id="element-947" />
                <GuardrailItem icon={<MessageSquare className="w-4 h-4" data-id="element-950" />} text="Social Media Guidelines" data-id="element-949" />
                <GuardrailItem icon={<Target className="w-4 h-4" data-id="element-952" />} text="Product Positioning" data-id="element-951" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-954" />} text="Crisis Communication" data-id="element-953" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-956" />} text="Executive Ghostwriting" data-id="element-955" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-957">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-958">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-959" />
                <span className="text-sm font-medium text-green-800" data-id="element-960">
                  Result: <span className="font-bold" data-id="element-961">100% on-brand</span>{' '}
                  outputs
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Closing */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-962">
          <p className="text-xl md:text-2xl font-light text-gray-800 leading-relaxed font-['Syne']" data-id="element-963">
            You know your regulatory boundaries. You know your brand standards.
            You know what your top performers do differently.
            <br data-id="element-964" />
            <br data-id="element-965" />
            <span className="font-bold text-black" data-id="element-966">
              What if that knowledge was machine-readable?
            </span>
          </p>
        </div>
      </div>
    </section>;
}
function GuardrailItem({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-3 text-gray-700" data-id="element-967">
      <div className="text-gray-400 flex-shrink-0" data-id="element-968">{icon}</div>
      <span className="text-sm font-medium" data-id="element-969">{text}</span>
    </div>;
}